import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage/index.jsx";
import Login from "../pages/Login";
import Register from "../pages/Register.jsx";
import CreateRequest from "../pages/CreateRequest";
import RequestSubmitted from "../pages/RequestSubmitted.jsx";
import PaymentMethod from "../pages/PaymentMethod";
import RecievedBids from "../pages/receivedBids/index";
import ExpertProfile from "../pages/userDetails/index";
import BookingConfirmed from "../pages/BookingConfirmed.jsx";
import BookingDetails from "../pages/myBookings/BookingDetails.jsx";
import CompleteRating from "../pages/myBookings/CompleteRating.jsx";
import MyRequests from "../pages/MyRequests.jsx";
import ChooseFlow from "../pages/ChooseFlow.jsx";
import ServiceProviderLogin from "../pages/ServiceProviderLogin.jsx";
import ServiceProviderRegister from "../pages/ServiceProviderRegister.jsx";
import AdminLogin from "../pages/AdminLogin.jsx";
import AdminDashboard from "../pages/AdminDashboard/index.jsx";
import ServiceProvider from "../pages/serviceProvider/ServiceProvider.jsx";
import Feeds from "../pages/Feeds/index.jsx";
import PersonalisedFeed from "../pages/PersonalisedFeed/index.jsx";
import UnderReview from "../pages/UnderRewiew.jsx";
import Chat from "../pages/Chat/index";
import MaintanenceMode from "../pages/MaintanenceMode.jsx";
import FindExperts from "../pages/FindExperts/index";
import MyBookings from "../pages/myBookings/index";
import RegistrationManager from "../pages/Admin/RegistrationManager.jsx";
import HRManager from "../pages/Admin/HRManager.jsx";
import PersonalInfo from "../pages/Admin/PersonalInfo.jsx";
import ServiceProvideInfoSuccess from "../pages/ServiceProvideInfoSuccess.jsx";
import PaymentSuccess from "../pages/PaymentSuccess.jsx";
import CategoriesManager from "../pages/Admin/CategoriesManager.jsx";
import AdminManager from "../pages/Admin/AdminManager.jsx";
import DisputesManager from "../pages/Admin/DisputesManager.jsx";
import MyEarnings from "../pages/MyEarnings.jsx";
import TipPaymentSuccess from "../pages/TipPaymentSuccess.jsx";
import UserStats from "../pages/Admin/UserStats.js";
import PersonalisedRequest from "../pages/PersonalisedRequest.jsx";
import AllUsers from "../pages/Admin/AllUsers.jsx";
import AllServiceProviders from "../pages/Admin/AllServiceProviders.jsx";

const PageRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/my-earnings" element={<MyEarnings />} />
          <Route
            path="/serviceProviderLogin"
            element={<ServiceProviderLogin />}
          />
          <Route
            path="/serviceProviderRegister"
            element={<ServiceProviderRegister />}
          />
          <Route path="/create-request" element={<CreateRequest />} />
          <Route
            path="/personalised-request/:id"
            element={<PersonalisedRequest />}
          />
          <Route path="/request-submitted" element={<RequestSubmitted />} />
          <Route path="/payment-method" element={<PaymentMethod />} />
          <Route path="/recieved-bids" element={<RecievedBids />} />
          <Route path="/booking-confirmed" element={<BookingConfirmed />} />
          <Route path="/complete-rating" element={<CompleteRating />} />
          <Route path="/my-requests" element={<MyRequests />} />
          <Route path="/choose-flow" element={<ChooseFlow />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/FindExperts" element={<FindExperts />} />
          <Route path="/my-bookings" element={<MyBookings />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route
            path="/ServiceProvideInfoSuccess/:id"
            element={<ServiceProvideInfoSuccess />}
          />
          <Route
            path="/admin/registration-manager"
            element={<RegistrationManager />}
          />
          <Route path="/admin/HR-manager" element={<HRManager />} />
          <Route path="/admin/Personal-Info" element={<PersonalInfo />} />
          <Route
            path="/admin/Categories-Manager"
            element={<CategoriesManager />}
          />
          <Route path="/admin/admin-manager" element={<AdminManager />} />
          <Route path="/admin/disputes-manager" element={<DisputesManager />} />
          <Route path="/admin/all-users" element={<AllUsers />} />
          <Route
            path="/admin/all-serviceProviders"
            element={<AllServiceProviders />}
          />
          <Route
            path="/my-bookings/booking-details"
            element={<BookingDetails />}
          />

          <Route path="/expert-profile/:id" element={<ExpertProfile />} />
          <Route path="/service-provider/info" element={<ServiceProvider />} />
          <Route path="/feeds" element={<Feeds />} />
          <Route path="/personalisedFeed" element={<PersonalisedFeed />} />

          <Route
            path="/service-provider/under-review"
            element={<UnderReview />}
          />
          <Route
            path="/paymentSuccess/:requestId/:currentRequestId"
            element={<PaymentSuccess />}
          />
          <Route
            path="/tipPaymentSuccess/:id/:amount"
            element={<TipPaymentSuccess />}
          />
          <Route path="/admin/user-stats" element={<UserStats />} />
        </Routes>
      </Router>
    </>
  );
};

export default PageRoutes;
